module.exports = __webpack_public_path__ + "img/de.b6a177d2.svg";